import cx from "classnames"
import { Code2 } from "lucide-react"
import { siClaude } from "simple-icons"
import OpenAIBlossom from "./static/openai-blossom.svg?react"

export interface AgentProviderVisuals {
    id: "anthropic" | "openai" | "other"
    quickButton: string
    quickSecondaryText: string
    pickerButton: string
    pickerMark: string
    pickerHeading: string
}

const CLAUDE_VISUALS: AgentProviderVisuals = {
    id: "anthropic",
    quickButton: "border-[#D97757] bg-[#D97757] text-[#241C18] hover:border-[#C96849] hover:bg-[#C96849]",
    quickSecondaryText: "text-[#241C18]/70",
    pickerButton: "border-[#D97757]/45 bg-[#D97757]/10 hover:bg-[#D97757]/20",
    pickerMark: "text-[#D97757]",
    pickerHeading: "text-[#D97757]",
}

const OPENAI_VISUALS: AgentProviderVisuals = {
    id: "openai",
    quickButton: "border-[#111111] bg-[#111111] text-white hover:border-[#2A2A2A] hover:bg-[#2A2A2A]",
    quickSecondaryText: "text-white/70",
    pickerButton: "border-base-content/30 bg-base-content/5 hover:bg-base-content/10",
    pickerMark: "text-base-content",
    pickerHeading: "text-base-content",
}

const FALLBACK_VISUALS: AgentProviderVisuals = {
    id: "other",
    quickButton: "border-border bg-base-200 text-base-content hover:bg-base-300",
    quickSecondaryText: "text-muted",
    pickerButton: "border-border bg-base-200 hover:bg-base-300",
    pickerMark: "text-base-content",
    pickerHeading: "text-muted",
}

export function agentProviderVisuals(harnessId: string): AgentProviderVisuals {
    if (harnessId === "claude-code") return CLAUDE_VISUALS
    if (harnessId === "codex") return OPENAI_VISUALS
    return FALLBACK_VISUALS
}

export function AgentProviderMark({ harnessId, className }: { harnessId: string; className?: string }) {
    const visuals = agentProviderVisuals(harnessId)
    if (visuals.id === "anthropic") {
        return (
            <svg aria-hidden="true" data-agent-mark="anthropic" viewBox="0 0 24 24" className={className} fill="currentColor">
                <path d={siClaude.path} />
            </svg>
        )
    }
    if (visuals.id === "openai") {
        return <OpenAIBlossom aria-hidden="true" data-agent-mark="openai" className={className} />
    }
    return <Code2 aria-hidden="true" data-agent-mark="other" className={cx("shrink-0", className)} />
}
